import React from 'react';

import { FormattedMessage } from 'react-intl';

import { SizeLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import messages from './messages';
import ReadonlyField from './readonly-field';

const Size = () => {
  const { dimensions } = useFulfillmentDisplayContext();

  return (
    <ReadonlyField label={<SizeLabel dimensionUnit={dimensions.unit} />}>
      <FormattedMessage {...messages.readonlyDimensions} values={dimensions} />
    </ReadonlyField>
  );
};

export default Size;
